import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import TextField from 'components/TextField/TextField';
import { VERIFICATION_CODE } from 'constants/formFields';
import { VERIFICATION_CODE_MASK } from 'constants/inputMasks';

import type { IVerificationCodeView } from './interfaces/IVerificationCodeView';

import styles from './sass/VerificationCodeView.module.scss';

function VerificationCodeView({
  control,
  onVerificationCodeSubmit,
  isValid,
  isLoading,
}:IVerificationCodeView) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className="authTitle">
        {t('login.title')}
      </div>
      <div className={styles.formWrapper}>
        <Controller
          control={control}
          name={VERIFICATION_CODE}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <TextField
              name={name}
              value={value}
              label={t('verificationCode.verificationCode')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              mask={VERIFICATION_CODE_MASK}
              required
              className={styles.inputWrapper}
            />
          )}
        />
      </div>
      <Button
        className={styles.button}
        title={t('common.continue')}
        onClick={onVerificationCodeSubmit}
        disabled={!isValid}
        isLoading={isLoading}
      />
    </div>
  );
}

export default VerificationCodeView;
